import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const routeLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  settings: 'Settings',
  playlists: 'Playlists',
  analytics: 'Analytics',
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Don't show breadcrumbs on dashboard (home)
  if (pathSegments.length <= 1 && pathSegments[0] === 'dashboard') {
    return null;
  }

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', path: '/dashboard' },
  ];

  let currentPath = '';
  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;
    breadcrumbs.push({
      label: routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1),
      path: isLast ? undefined : currentPath,
    });
  });

  return (
    <nav className="flex items-center gap-1 text-sm text-gray-400 mb-4" aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="w-4 h-4 text-gray-600" />}
          {crumb.path ? (
            <Link
              to={crumb.path}
              className="flex items-center gap-1 hover:text-white transition-colors"
            >
              {index === 0 && <Home className="w-3.5 h-3.5" />}
              {crumb.label}
            </Link>
          ) : (
            <span className="text-gray-200 font-medium">{crumb.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
